import { render, staticRenderFns } from "./ReplyMessage.vue?vue&type=template&id=5dd4fca0&scoped=true&"
import script from "./ReplyMessage.vue?vue&type=script&lang=js&"
export * from "./ReplyMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReplyMessage.vue?vue&type=style&index=0&id=5dd4fca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd4fca0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/dan/github/webdev-personal/dan-anan-wedding/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VContainer,VFlex,VLayout})
